import * as React from "react";
import { RootState } from "config/store";
import { useSnackbar, SnackbarKey } from "notistack";
import { useDispatch, useSelector } from "react-redux";
import { removeSnackbar } from "shared/reducers/application";

let displayed: SnackbarKey[] = [];

export default function Notifier() {
  const dispatch = useDispatch();
  const notifications = useSelector((state: RootState) => state.application.notifications ?? []);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const storeDisplayed = (id: SnackbarKey) => {
    displayed.push(id);
  };

  const removeDisplayed = (id: SnackbarKey) => {
    displayed = displayed.filter(key => id !== key);
  };

  React.useEffect(() => {
    notifications.forEach(({ key, message, options = {}, dismissed = false }) => {
      if (dismissed) {
        closeSnackbar(key);
        return;
      }

      if (displayed.includes(key)) return;

      enqueueSnackbar(message, {
        key,
        ...options,
        onClose: (event, reason, myKey) => {
          if (options.onClose) {
            options.onClose(event, reason, myKey);
          }
        },
        onExited: (event, myKey) => {
          dispatch(removeSnackbar(myKey));
          removeDisplayed(myKey);
        },
      });

      storeDisplayed(key);
    });
  }, [notifications, closeSnackbar, enqueueSnackbar, dispatch]);

  return null;
}
